import mahanLogo from "@assets/images/mahan-logo.svg";
import maintenance from "@assets/images/maintenance.gif";
import Config from "@service/Config";
import Splash from "@service/Splash";
import Storage from "@service/Storage";
import { FC } from "react";

interface IUnderMaintenanceProps { }

const UnderMaintenance: FC<IUnderMaintenanceProps> = () => {
    Splash.hide();
    const dir = Storage.get("dir");

    return (
        <div className={`under-maintenance ${dir}`}>
            <img className="under-maintenance-logo" src={mahanLogo} alt="mahan logo" />
            <div id="info" className="under-maintenance-txt" dangerouslySetInnerHTML={{ __html: Config.config.setting.underMaintenanceMessage?.html ?? "" }} />
            <img className="under-maintenance-img" src={maintenance} alt="maintenance animation" />
        </div>
    );
}

export default UnderMaintenance;
